import styled from 'styled-components';

const theme = {
  surface: '#252836',
  accent: '#ff79c6',
  text: '#f8f8f2',
  textSecondary: '#bd93f9',
  border: '#44475a',
  bg: '#1C1E2A',
};

export const ChartContainer = styled.div`
  // background-color: ${theme.surface};
  background: linear-gradient(135deg, #111827, #1f2937);
  border-radius: 16px;
  padding: 1.5rem 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  border: 1px solid ${theme.border};
`;

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: ${theme.text};
  margin: 0;
`;

export const FilterGroup = styled.div`
  display: flex;
  background-color: ${theme.bg};
  border-radius: 8px;
  padding: 4px;
`;

export const FilterButton = styled.button`
  background-color: ${({ active }) => (active ? theme.accent : 'transparent')};
  color: ${({ active }) => (active ? 'white' : theme.textSecondary)};
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover:not(:disabled) {
    background-color: ${({ active }) => (active ? theme.accent : theme.border)};
    color: white;
  }
`;

export const ChartWrapper = styled.div`
  position: relative;
  min-height: 350px;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(37, 40, 54, 0.7);
  backdrop-filter: blur(2px);
  z-index: 10;
  border-radius: 12px;
`;